import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-part1',
  templateUrl: './part1.component.html',
  styleUrls: ['./part1.component.scss']
})
export class Part1Component implements OnInit {
  bShowVideo = false;
  readonly baseURL = './assets/images/part1/';

  constructor() { }

  ngOnInit(): void {
  }
  closeModal() {
    this.bShowVideo = false
  }
}
